module.exports = __webpack_public_path__ + "static/media/mo.d41e1eb0.svg";